import { useState } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  ForgotPasswordContainer,
  Banner,
  SecurityRules,
  SecurityRulesInfo,
  SecurityRulesForm,
  EmailForm,
  ForgotPasswordForm,
  PasswordMatch
} from './forgotPassword.styles';
import { Link } from 'react-router-dom';

import useToggleVisible from 'src/hooks/useToggleVisible';

import ModalCodeSuccess from 'src/components/shared/modals/codeSuccess/codeSuccess';
import ModalPasswordForgotSuccess from 'src/components/shared/modals/forgotPassword/forgotPassword';

export default function ForgotPassword() {
  const [data, setData] = useState({ password: '' });
  const [userIsNotAuthenticated, setUserIsNotAuthenticated] = useState(false);
  const [code, setCode] = useState();
  const [passwordMatch, setPasswordMatch] = useState();
  const [ForgotPassword, setForgotPassword] = useState(false);
  const [passwordForgotSuccess, setPasswordForgotSuccess] = useState(false);
  const [userNotFound, setUserNotFound] = useState(false);
  const [isPasswordValidated, setIsPasswordValidated] = useState();
  const [isConfirmPasswordValidated, setIsConfirmPasswordValidated] = useState();
  const [upperCase, setUpperCase] = useState('-');
  const [lowerCase, setLowerCase] = useState('-');
  const [number, setNumber] = useState('-');
  const [specialCharacter, setSpecialCharacter] = useState('-');
  const [minLength, setMinLength] = useState('-');
  const [type, setType] = useState('password');

  const handleEmail = (e) => (data[e.target.name] = e.target.value);

  let navigate = useNavigate();
  const location = useLocation();
  const handleCode = (e) => setCode(e.target.value);

  const handlePassword = (e) => {
    const passwordRegex = new RegExp(
      '^(?=(.*[A-Z]){1,})(?=(.*[a-z]){1,})(?=(.*[0-9]){1,})(?=(.*[_.@$%&-/#?¿*]){1,}).{8,}$'
    );

    const upperCase = new RegExp('^(?=.*[A-Z]).+$');
    const lowerCase = new RegExp('^(?=.*[a-z]).+$');
    const number = new RegExp('^(?=.*[0-9]).+$');
    const specialCharacter = new RegExp('^(?=.*[_.@$%&-/#?¿*]).+$');
    const minLength = new RegExp('^.{8,}$');

    setUpperCase(upperCase.test(e.target.value));
    setLowerCase(lowerCase.test(e.target.value));
    setNumber(number.test(e.target.value));
    setSpecialCharacter(specialCharacter.test(e.target.value));
    setMinLength(minLength.test(e.target.value));

    if (passwordRegex.test(e.target.value)) {
      setIsPasswordValidated(true);
      data[e.target.name] = e.target.value;
    } else {
      setIsPasswordValidated(false);
      data[e.target.name] = false;
    }
  };

  const handleConfirmPassword = (e) => {
    const confirmPasswordRegex = new RegExp(
      '^(?=(.*[A-Z]){1,})(?=(.*[a-z]){1,})(?=(.*[0-9]){1,})(?=(.*[_.@$%&-/#?¿*]){1,}).{8,}$'
    );

    if (confirmPasswordRegex.test(e.target.value)) {
      setIsConfirmPasswordValidated(true);
      data[e.target.name] = e.target.value;
    } else {
      setIsConfirmPasswordValidated(false);
      data[e.target.name] = false;
    }
  };

  const sendEmailToServer = async () => {
    try {
      await Auth.forgotPassword(data.email);
      setForgotPassword(true);
    } catch (error) {
      console.error('Error Forgot Password:', error);
      error.message === 'Username/client id combination not found.' && setUserNotFound(true);
    }
  };

  const SendCodeToServer = async () => {
    if (data.password === data.confirmPassword) {
      try {
        const forgot = await Auth.forgotPasswordSubmit(data.email, code, data.password);
        setPasswordForgotSuccess(true);
        navigate(`/iniciar-sesion`);
        // const user = location.pathname.split('/')[1];
        // navigate(`/iniciar-sesion`);
      } catch (error) {
        console.error('Error Forgot Password Submit:', error);
        error === 'The user is not authenticated' && setUserIsNotAuthenticated(true);
      }
    } else {
      setPasswordMatch(false);
    }
  };

  return (
    <ForgotPasswordContainer>
      <ModalCodeSuccess showModalCodeSuccess={ForgotPassword} />
      <ModalPasswordForgotSuccess showModalPasswordForgotSuccess={passwordForgotSuccess} />
      <Banner>
        <h2>Olvidaste tu contraseña</h2>
        <p>
          Para cambiar tu contraseña, por favor completa ambos campos, considerando las siguientes
          reglas y deben coincidir entre ellas:
        </p>
      </Banner>
      <SecurityRules>
        <SecurityRulesInfo>
          <p>
            Recuerda que tu nueva contraseña debe seguir las siguientes reglas de seguridad para
            transacciones en <span>FinSphera</span>:
          </p>
          <ul>
            <li>
              <p>Debe tener un largo mínimo de 8 carácteres</p>
              <figure>
                {minLength ? (
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                    alt="icono de acierto"
                  />
                ) : (
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                    alt="icono de error"
                  />
                )}
              </figure>
            </li>
            <li>
              <p>Debe incluir al menos una letra en mayúscula.</p>
              <figure>
                {upperCase ? (
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                    alt="icono de acierto"
                  />
                ) : (
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                    alt="icono de error"
                  />
                )}
              </figure>
            </li>
            <li>
              <p>Debe incluir al menos una letra en minúscula.</p>
              <figure>
                {lowerCase ? (
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                    alt="icono de acierto"
                  />
                ) : (
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                    alt="icono de error"
                  />
                )}
              </figure>
            </li>
            <li>
              <p>Debe contener al menos un dígito del 0 al 9.</p>
              <figure>
                {number ? (
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                    alt="icono de acierto"
                  />
                ) : (
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                    alt="icono de error"
                  />
                )}
              </figure>
            </li>
            <li>
              <p>Debe contener al menos un símbolo especial de tipo _.@$%&-/#?¿*</p>
              <figure>
                {specialCharacter ? (
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                    alt="icono de acierto"
                  />
                ) : (
                  <img
                    src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                    alt="icono de error"
                  />
                )}
              </figure>
            </li>
          </ul>
        </SecurityRulesInfo>
        <SecurityRulesForm isPasswordMatch={passwordMatch}>
          {ForgotPassword === false ? (
            <EmailForm>
              <input
                type="email"
                name="email"
                placeholder="Correo electrónico"
                onChange={handleEmail}
              />
              {userNotFound && (
                <p>
                  El correo electrónico ingresado no existe en la plataforma, vuelve a intentarlo o
                  Registrate dando click <Link to="/registro">aquí</Link>
                </p>
              )}
              <button onClick={sendEmailToServer}>Enviar</button>
            </EmailForm>
          ) : (
            <EmailForm></EmailForm>
          )}
          {ForgotPassword ? (
            <ForgotPasswordForm>
              <div>
                <input
                  type="text"
                  name="code"
                  placeholder="Ingrese el código"
                  onChange={handleCode}
                />
                {/* {code === null && (
                  <PasswordMatch>
                    Debes ingresar el código para recuperar tu contraseña
                  </PasswordMatch>
                )} */}
              </div>
              <div>
                <input
                  type={type}
                  name="password"
                  placeholder="Contraseña"
                  onChange={handlePassword}
                />
                <figure>
                  {isPasswordValidated === true && (
                    <img
                      src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                      alt="icono de acierto"
                    />
                  )}
                  {isPasswordValidated === false && (
                    <img
                      src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                      alt="icono de error"
                    />
                  )}
                </figure>
                {type === 'password' ? (
                  <figure onClick={() => setType('text')}>
                    <img
                      src="https://finsphera-webapp-resources.s3.amazonaws.com/iconoUnlockPassword.png"
                      alt="icono mostrar contraseña"
                    />
                  </figure>
                ) : (
                  <figure onClick={() => setType('password')}>
                    <img
                      src="https://finsphera-webapp-resources.s3.amazonaws.com/Eye-Open.png"
                      alt="icono mostrar contraseña"
                    />
                  </figure>
                )}
              </div>
              <div>
                <input
                  type={type}
                  name="confirmPassword"
                  placeholder="Confirmar contraseña"
                  onChange={handleConfirmPassword}
                />
                <figure>
                  {isConfirmPasswordValidated === true && (
                    <img
                      src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_success_value.png"
                      alt="icono de acierto"
                    />
                  )}
                  {isConfirmPasswordValidated === false && (
                    <img
                      src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_modal_error_value.png"
                      alt="icono de error"
                    />
                  )}
                </figure>
                {type === 'password' ? (
                  <figure onClick={() => setType('text')}>
                    <img
                      src="https://finsphera-webapp-resources.s3.amazonaws.com/iconoUnlockPassword.png"
                      alt="icono mostrar contraseña"
                    />
                  </figure>
                ) : (
                  <figure onClick={() => setType('password')}>
                    <img
                      src="https://finsphera-webapp-resources.s3.amazonaws.com/Eye-Open.png"
                      alt="icono mostrar contraseña"
                    />
                  </figure>
                )}
              </div>
              {passwordMatch === false && (
                <PasswordMatch>
                  Tu nueva contraseña y su confirmación deben coincidir.
                </PasswordMatch>
              )}
              <button onClick={SendCodeToServer}>Enviar</button>
              <p>
                ¿Recordaste tu contraseña? Inicia sesión dando click{' '}
                <Link to="/iniciar-sesion">aquí</Link>
              </p>
            </ForgotPasswordForm>
          ) : (
            <ForgotPasswordForm />
          )}
        </SecurityRulesForm>
      </SecurityRules>
    </ForgotPasswordContainer>
  );
}
